export const isDefined = (value: any) => value !== undefined;
